export const validaremail = (text) => {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (reg.test(text) === false) {
    return false;
  } else {
    return true;
  }
};

export const convertirFicheroBlob = async (rutafisica) => {
  const fichero = await fetch(rutafisica);
  console.log("FICHERO");
  console.log(fichero);
  const blob = await fichero.blob();

  return blob;
};

export function generatePasswordRand(length, type) {
  let characters = "";
  switch (type) {
    case "num":
      characters = "0123456789";
      break;
    case "alf":
      characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      break;
    case "rand":
      //FOR ↓
      break;
    default:
      characters =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      break;
  }
  let pass = "";
  let i = 0;
  for (i = 0; i < length; i++) {
    if (type === "rand") {
      pass += String.fromCharCode((Math.floor(Math.random() * 100) % 94) + 33);
    } else {
      pass += characters.charAt(Math.floor(Math.random() * characters.length));
    }
  }
  return pass;
}

export const sendEmail = async (body, subject, destination) => {
  let url = `https://us-central1-sayeret-1aba9.cloudfunctions.net/sendemail?body=${body}&subject=${subject}&destination=${destination}`;
  await getData(url).then((data) => {
    console.log("RESPUESTA DE ENVIAR CORREO");
    console.log(data);
  });
};

export const sendEmailWithCopy = async (body, subject, destination, cc) => {
  let url = `https://us-central1-sayeret-1aba9.cloudfunctions.net/sendemailwithcopy?body=${body}&subject=${subject}&destination=${destination}&cc=${cc}`;
  await getData(url).then((data) => {
    console.log("RESPUESTA DE ENVIAR CORREO");
    console.log(data);
  });
};

async function getData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "no-cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit

    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response; // parses JSON response into native JavaScript objects
}
